import { showError } from './utils';
import axios from 'axios';
import {
  getAuthGenerationV104,
  isAuthEntryRequestV104,
} from './authSessionV104';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '',
});

API.interceptors.request.use((config) => {
  config.authGenerationV104 = getAuthGenerationV104();
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) return Promise.reject(error);
    if (
      error.response?.status === 401 &&
      isAuthEntryRequestV104(error.config?.url)
    ) {
      // Auth forms already handle the backend's success/message envelope.
      return {
        ...error.response,
        data: {
          success: false,
          message: error.response.data?.message || error.message,
        },
      };
    }
    if (error.config?.keyOptionsV1110 || error.config?.organizationReadV1116) {
      // These reads display one inline retry state; retain session expiry.
      // Preserve the rejection so failed organization reads cannot become undefined.
      if (error.response?.status === 401) showError(error);
      return Promise.reject(error);
    }
    showError(error);
  }
);
